import * as bootstrap from 'bootstrap';

jQuery(document).ready(function($) {

    const textEditor = $('#texts-editor');
    if (textEditor.length) {

        let multiEdit = $('#multiedit');
        multiEdit.on('change', '#move_texts', function () {
            let groupId = $(this).val();
            if (groupId) {
                let targetName = $(this).find('option').get(this.selectedIndex).innerHTML;
                if (confirm("Sollen alle ausgewählten Texte verschoben werden?")) {
                    let selected = textEditor.find('input.text-check:checked');
                    let selectedRows = selected.map(function () {
                        return $(this).parents('tr');
                    }).get();
                    let selectedWords = selected.map(function () {
                        return this.value;
                    }).get();

                    if (selectedWords.length > 0) {
                        $.get('/admin/texts/move?id=' + selectedWords.join(',') + '&tg=' + groupId);
                        $.each(selectedRows, function (i, row) {
                            row.find('button[data-action="move"]').toggleClass('active');
                            row.find('.move-select').toggleClass('d-none');
                            row.find('td').addClass('bg-warning');
                            window.setTimeout(function () {
                                row.remove();
                            }, 280)
                        });
                        toast('Es wurden ' + selectedWords.length + ' Texte nach "'+ targetName + '" verschoben', 'Texte verschieben');
                    }
                }
            }
        });
        multiEdit.on('change', '#copy_texts', function(){
            let groupId = $(this).val();
            if (groupId) {
                let targetName = $(this).find('option').get(this.selectedIndex).innerHTML;
                if (confirm("Sollen alle ausgewählten Texte kopiert werden?")) {
                    let selected = textEditor.find('input.text-check:checked');
                    let selectedWords = selected.map(function(){ return this.value; }).get();
                    if (selectedWords.length > 0) {
                        $.get('/admin/texts/copy?id=' + selectedWords.join(',') + '&tg=' + groupId);
                        toast('Es wurden ' + selectedWords.length + ' Texte nach "'+ targetName + '" kopiert', 'Texte kopieren');
                    }

                    this.selectedIndex = 0;
                }
            }
        });

        $('#text-filter select').on('change', function(e) {
            $(this).parents('form').submit();
        });

        $('#text-filter input[type="search"]').on('input', function(e) {
            if (!e.currentTarget.value && !e.inputType) {
                $(this).parents('form').submit();
            }
        });

        textEditor.on('click', 'input.text-check', function () {
            let selected = textEditor.find('input.text-check:checked');
            let selectedWords = selected.map(function () {
                return this.value;
            }).get();
            if (selectedWords.length > 0) {
                multiEdit.show();
            } else {
                multiEdit.hide();
            }
        });

        textEditor.on('click', 'button', function(e) {
            let button = $(this);
            e.preventDefault();

            if ($(this).data('action') === 'edit') {
                let tr = $(this).parents('tr');
                let id = tr.data('row');
                $.get('/admin/texts/' + id, function(editHtml){
                    const modalElement = $(editHtml);

                    $('.edit-modal').each(function () {
                        $(this).modal('hide');
                        $(this).remove();
                    });

                    $('body').append(modalElement);
                    const modalObj = new bootstrap.Modal(modalElement.get(0))
                    modalObj.show();
                });
            }

            if ($(this).data('action') === 'delete') {
                if (confirm('Wollen Sie den Text wirklich löschen?')) {
                    let tr = $(this).parents('tr');
                    let id = tr.data('row');
                    $.post('/admin/texts/' + id, {_method:'DELETE'}, function(r){
                        console.log(r);
                        tr.remove();
                    });
                }
            }

            return false;
        });
    }

});
